import React from 'react';
import { Card, CardBody } from '@material-tailwind/react';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import LoadingPanel from './LoadingPanel';

const MonthlyInvoiceAmountReport = ({
  summaryLoading,
  amountChart,
  statusColors,
  formatMoney
}) => {
  if (summaryLoading) {
    return <LoadingPanel label="Loading amount summary..." />;
  }

  return (
    <Card className="shadow-lg">
      <CardBody className="p-0">
        <div className="border-b border-slate-200 px-5 py-4">
          <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Invoice amount chart</div>
        </div>
        <div className="h-[320px] px-6 py-4">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={amountChart} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="month_label" tickMargin={10} />
              <YAxis width={100} tickMargin={8} tickFormatter={(value) => formatMoney(value)} />
              <Tooltip formatter={(value) => formatMoney(value)} />
              <Legend />
              <Bar dataKey="DRAFT" stackId="invoice-amount" fill={statusColors.DRAFT || '#f59e0b'} />
              <Bar dataKey="SENT" stackId="invoice-amount" fill={statusColors.SENT || '#0ea5e9'} />
              <Bar dataKey="PAID" stackId="invoice-amount" fill={statusColors.PAID || '#10b981'} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardBody>
    </Card>
  );
};

export default MonthlyInvoiceAmountReport;
